/*
 * Helpers for working with API client responses that may wrap list payloads.
 */

/**
 * Normalizes various API list response shapes into a plain array.
 * Handles direct arrays, paginated objects with `results`, and fetch responses
 * that expose the payload under a `data` property.
 */
export function extractListData<T>(input: unknown): T[] {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input as T[];
  }

  if (typeof input === "object") {
    const record = input as Record<string, unknown>;

    const data = record.data;
    if (Array.isArray(data)) {
      return data as T[];
    }
    if (data && typeof data === "object") {
      const nested = extractListData<T>(data);
      if (nested.length) {
        return nested;
      }
    }

    const results = record.results;
    if (Array.isArray(results)) {
      return results as T[];
    }
  }

  return [];
}
